import { useEffect, useState } from "react";
import { Accordion, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components"
import { changeLocation } from "../../../reducer/locationSlice";

const BtnToggle = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    right: 0;
    border: 1px solid rgba(231, 234, 243, 1);
    border-radius: 100%;
    width: 35px;
    height: 35px;
    background-color: #fff;
    flex-shrink: 0;
    transform: translate(50%, 15px);
    z-index: 1;
    cursor: pointer;
    transition: transform 0.3s;
    .bi-arrow-bar-left {
        transition: transform 0.3s;

        &.show-menu {
            display: none;
        }
    }
`;

const NavWrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 250px;
    height: 100%;

    .logo {
        position: sticky;
        top: 0;
        flex-shrink: 0;
        flex-grow: 0;
        margin: 0;
        height: 140px;
        padding: 25px;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .side-bar-nav {
        flex-direction: column;
        position: relative;
        padding-left: 10px;
        margin-top: 5px;
        gap: 5px 0;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            width: 3px;
            background-color: rgba(231, 234, 243, 0.7);
            left: 0px;
        }

        a {
            display: block;
            width: 100%;
            height: 100%;
            padding: 8px 10px;
            border-radius: 10px;
            color: #000;
            text-decoration: none;
            font-weight: 500;
            font-size: 14px;

            &.active,
            &:hover {
                background-color: rgba(189, 197, 209, 0.2);
            }
        }
    }
`;

const BottomMenuWrap = styled.div`
    padding: 20px;
    border-top: 1px solid rgba(189, 197, 209, 0.2);
    width: 100%;
    white-space: nowrap;

    .logo {
        margin: 0 auto;
        width: 150px;
        img {
            display: block;
            width: 100%;
            object-fit: contain;
        }
    }
}
`;

const Wrap = styled.div`
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100dvh;
    width: 250px;
    flex-shrink: 0;
    border-right: 1px solid rgba(231, 234, 243, 0.7);
    transition: width 0.3s;

    &.hide {
        width: 100px;
        min-width: 100px;

        .category {
            border-top: 1px solid rgba(231, 234, 243, 0.7);
            > span {
                opacity: 0;
            }
        }

        ${NavWrap} {
            width: 100%;
            > .logo {
                opacity: 0;
            }
        }
        
        .accordion {
            overflow: visible;
            .accordion-item {
                position: relative;
                .title {
                    display: none;
                }

                .accordion-header {

                    .accordion-button {
                        &::after {
                            opacity: 0;
                            margin: 0;
                            width: 0;
                        }
                    }
                    &:hover {
                        & + .accordion-collapse {
                            display: block !important;
                        }
                    }
                }
                .accordion-collapse {
                    display: none;
                    transition: none;
                    position: absolute;
                    top: 0;
                    left: 100%;
                    width: 180px;
                    z-index: 1;
                    
                    &:hover {
                        display: block;
                    }
                    
                    .accordion-body {
                        padding: 10px;
                        transform: translateX(30px);
                        background-color: #fff;
                        box-shadow: 0 .6125rem 2.5rem .6125rem rgba(140,152,164,.175);
                        border-radius: 10px;
                    }

                    .side-bar-nav {
                        &::before {
                            display: none;
                        }
                        padding-left: 0;
                        margin-top: 0;
                    }
                }
            }
        }

        ${BottomMenuWrap} {
            .text {
                display: none;
            }

            .logo {
                opacity: 0;
            }

        }
        ${BtnToggle} {
            .bi-arrow-bar-left {
                transform: rotate(180deg);
            }
        }
    }

    .accordion {
        overflow: auto;
        flex: 1 1;
        height: 100%;
        padding: 1.25rem;

        &::-webkit-scrollbar {
            width: 0.6125rem;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(189, 197, 209, 0.6);
        }
        * {
            border: none;
        }

        > a {
            display: block;
            border-radius: 10px;
        }

        .accordion-header {
            border-radius: 10px;

            &:hover {
                background-color: rgba(189, 197, 209, 0.2);
            }
        }
        .single.accordion-header {
            .accordion-button {
                &::after {
                    opacity: 0;
                }
            }
        }

        .accordion-button {
            position: relative;
            box-shadow: none;
            background-color: transparent;
            color: #000;

            > a {
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                color: #000;
                padding: inherit;

                &.active {
                    color: #377dff;
                }
            }

            &:not(.collapsed) {
                color: #377dff;

                &::after {
                    transform: rotate(180deg);
                }
            }

            &::after {
                background-image: url("data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='%23677788' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3e%3c/svg%3e");
            }
        }
        .accordion-item {
            background-color: inherit;

            .title {
                white-space: nowrap;
            }
        }
    }
`;

const NavSideBar = () => {
    const [isHide, setIsHide] = useState(parseInt(window.localStorage.getItem("digilog_nav_toggle")));
    const { companyId, branchId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loginInfo = useSelector(state => state.login);

    const [eventKey, setEventKey] = useState(companyId);

    useEffect(() => {
        window.localStorage.setItem("digilog_nav_toggle", isHide);
    }, [isHide]);

    useEffect(() => {
        window.localStorage.setItem("digilog_nav_toggle", isHide);
    }, []);
    
    useEffect(() => {
        setEventKey(companyId);
    }, [companyId])

    return (
        <div className="position-relative" style={{ zIndex: 100 }}>
            <Wrap className={isHide ? "hide" : ""}>
                <BtnToggle
                    onClick={() => {
                        if (isHide) {
                            setIsHide(0);
                        } else {
                            setIsHide(1);
                        }
                    }}
                >
                    <div className="bi-arrow-bar-left"></div>
                </BtnToggle>
                <NavWrap>
                    <h2 className="logo">
                        {
                            loginInfo.header &&
                            loginInfo.header.logoFilePath ?
                            <img src={loginInfo.header.logoFilePath} alt="" />
                            : <></>
                        }
                    </h2>

                    <Accordion activeKey={eventKey} onSelect={(e) => {
                        setEventKey(e)
                        
                        const menu = loginInfo.menuList.find(el => el.companyId == e);
                        if (menu) {
                            if (menu.branch.length > 1) { // 지점이 2개 이상일 경우
                                // 첫 번째 업체 > 전체
                                navigate("/main/dashboard/" + menu.companyId + "/0")
                            } else {
                                // 첫 번째 업체 > 첫 번째 지점
                                navigate("/main/dashboard/" + menu.companyId + "/" + menu.branch[0].id)
                            }
                        }
                    }}>
                        {/* --- 대시보드 --- */}
                        {
                        loginInfo.admin.level == 1 &&
                        <>
                        <div className="dropdown-header mt-4 category">
                            <span>
                                대시보드
                            </span>
                        </div>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header className="single">
                                <NavLink to="/dashboard" className="d-flex align-items-center">
                                    <div className="bi-house nav-icon"></div>
                                    <div className="title">대시보드</div>
                                </NavLink>
                            </Accordion.Header>
                        </Accordion.Item>
                        </>
                        }

                        {/* --- 업체 --- */}
                        <div className="dropdown-header mt-4 category">
                            <span>
                                업체
                            </span>
                        </div>
                        {
                            loginInfo.menuList &&
                            loginInfo.menuList.map((val, idx) => {
                                if (companyId == val.companyId) {
                                    dispatch(changeLocation({
                                        company: val.companyName,
                                    }));
                                }
                                return (
                                    <Accordion.Item key={val.companyId} eventKey={val.companyId.toString()}>
                                        <Accordion.Header>
                                            <div className="d-flex align-items-center">
                                                <div className="bi-building nav-icon"></div>
                                                <div className="title">
                                                    {val.companyName}
                                                </div>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Nav activeKey={companyId + "/" + branchId} 
                                                className="side-bar-nav" 
                                                onSelect={(selectKey, e) => {
                                                    navigate(e.target.getAttribute("to"));
                                                    let branchName = "";
                                                    val.branch.map(el => {
                                                        const selectBranch = selectKey.split("/")[1];
                                                        if (selectBranch != 0) {
                                                            if (el.id == selectBranch) {
                                                                branchName = el.name;
                                                            }
                                                        } else {
                                                            branchName = "전체";
                                                        }

                                                        dispatch(changeLocation({
                                                            company: val.companyName,
                                                            branch: branchName
                                                        }));
                                                    })
                                            }}>
                                                {
                                                (val.branch.length > 1 && loginInfo.admin.level < 3) &&
                                                <Nav.Item>
                                                    <Nav.Link eventKey={val.companyId + "/0"} to={"/main/dashboard/" + val.companyId + "/0"}>전체</Nav.Link>
                                                </Nav.Item>
                                                }
                                                {
                                                    val.branch.map((val2, idx2) => {
                                                        if (val2.id == branchId) {
                                                            dispatch(changeLocation({
                                                                company: val.companyName,
                                                                branch: val2.name
                                                            }));
                                                        }
                                                        if (branchId == 0) {
                                                            if (companyId == val.companyId) {
                                                                dispatch(changeLocation({
                                                                    company: val.companyName,
                                                                    branch: "전체"
                                                                }));
                                                            }
                                                        }
                                                        return (
                                                            <Nav.Item key={idx2}>
                                                                <Nav.Link eventKey={val.companyId + "/" + val2.id}
                                                                            to={"/main/dashboard/"+ val.companyId +"/" + val2.id}
                                                                >
                                                                {val2.name}        
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                        )
                                                    })
                                                }
                                            </Nav>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                );
                            })
                        }
                    </Accordion>
                </NavWrap>
                <BottomMenuWrap>
                    {
                    loginInfo.admin.level < 4 &&
                    <Link to={loginInfo.admin.level < 3 ? "/admin/list/company" : "/admin/list/branch"} className={`btn btn-white w-100 mb-3 d-flex align-items-center justify-content-center gap-2`} 
                    onClick={(e) => {
                        setEventKey(999)
                    }}>
                        <div className="bi-gear"></div>
                        <span className="text">
                            관리자 설정
                        </span>
                    </Link>
                    }
                    <div className="logo">
                        <img src={process.env.PUBLIC_URL + "/image/img_logo_digilog.svg"} />
                    </div>
                </BottomMenuWrap>
            </Wrap>
        </div>
    );
}

export default NavSideBar;